@if (isInitialized) {
  <oe-modal [title]="this.component.alias" [component]="component" [formGroup]="formGroup">
    <oe-modal-line [name]="'GENERAL.STATE' | translate" [channelAddress]="component.id + '/_PropertyMode'"
      [converter]="CONVERT_MANUAL_ON_OFF">
    </oe-modal-line>
    @if (formGroup.value.mode === 'MANUAL_ON') {
      <oe-modal-line [name]="chargeDischargePower.name" [value]="chargeDischargePower.value"
        [converter]="CONVERT_TO_WATT">
      </oe-modal-line>
    }
    <oe-modal-horizontal-line></oe-modal-horizontal-line>
  <oe-modal-buttons [formGroup]="formGroup" controlName="mode" [component]="component" [buttons]="[
    { name: ('GENERAL.ON' | translate), value: 'MANUAL_ON', icon: {color:'success', name: 'play-outline'}},
    { name: ('GENERAL.OFF' | translate), value: 'MANUAL_OFF', icon: {color:'danger', name: 'power-outline'}}]">
    </oe-modal-buttons>
    <oe-modal-horizontal-line></oe-modal-horizontal-line>
    @if (formGroup.value.mode === 'MANUAL_ON') {
      <oe-modal-line [name]="'GENERAL.POWER'| translate" [formGroup]="formGroup" controlName="power"
        [control]="{type: 'INPUT'}">
      </oe-modal-line>
      <oe-modal-horizontal-line></oe-modal-horizontal-line>
    }
    <oe-modal-info-line
      [info]="('EDGE.INDEX.WIDGETS.INFO_STORAGE_FOR_CHARGE' | translate) + '. ' + ('EDGE.INDEX.WIDGETS.INFO_STORAGE_FOR_DISCHARGE' | translate)">
    </oe-modal-info-line>
  </oe-modal>
}
